import compact from 'lodash/compact'
import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'

import { selectedGrowthShrimpIdState } from '../stores/atom'
import { useGetGrowthShrimps } from './queries'

export const useGrowthShrimps = (enabled: boolean = true) => {
  const { data, ...rest } = useGetGrowthShrimps(enabled)

  return useMemo(
    () => ({
      ...rest,
      data: compact((data?.pages ?? []).map((page) => page.shrimps).flat()),
    }),

    [data]
  )
}

export const useFindGrowthShrimpById = () => {
  const id = useRecoilValue(selectedGrowthShrimpIdState)
  const { data } = useGrowthShrimps()
  return useMemo(() => data.find((el) => el.id === id), [data, id])
}
